<template>
  <div>
    <v-row class="fill-height">
      <v-col>
        <template>
          <v-card
              class="mx-auto"
              max-width="500"
          >
            <v-toolbar
                color="secondary"
                dark
                style="margin: 0 2em"

            >
              <v-toolbar-title>

                <v-tabs
                    v-model="tab"
                    background-color="transparent"
                    color="basil"
                    grow
                >
                  <v-tab>
                    Günlük Görevler
                  </v-tab>
                  <v-tab>
                    Ödevler
                  </v-tab>
                </v-tabs>

              </v-toolbar-title>


            </v-toolbar>

            <v-list two-line>
              <v-list-item-group
              >
                <v-tabs-items v-model="tab">
                  <v-tab-item>
                    <template v-for="(item, index) in homeworksDaily">
                      <v-list-item :key="item.title">
                        <v-list-item-content>
                          <v-list-item-title v-text="item.homeworkManager.name"></v-list-item-title>


                          <v-list-item-subtitle v-text="item.homeworkManager.eventSummary"></v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action @click="deleteHomework(index,item)">

                          <v-icon
                              color="success"
                          >
                            mdi-checkbox-marked-circle
                          </v-icon>

                        </v-list-item-action>
                      </v-list-item>

                      <v-divider
                          v-if="index < homeworksDaily.length - 1"
                          :key="index"
                      ></v-divider>
                    </template>
                  </v-tab-item>
                  <v-tab-item>
                    <template v-for="(item, index) in homeworksNotDaily">
                      <v-list-item :key="item.title">
                        <v-list-item-content>
                          <v-list-item-title v-text="item.homeworkManager.name"></v-list-item-title>


                          <v-list-item-subtitle v-text="item.homeworkManager.eventSummary"></v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action-text v-text="item.homeworkManager.end"></v-list-item-action-text>
                        <v-list-item-action @click="deleteHomework(index,item)">

                          <v-icon
                              color="success"
                          >
                            mdi-checkbox-marked-circle
                          </v-icon>

                        </v-list-item-action>
                      </v-list-item>

                      <v-divider
                          v-if="index < homeworksNotDaily.length - 1"
                          :key="index"
                      ></v-divider>
                    </template>
                  </v-tab-item>
                </v-tabs-items>


              </v-list-item-group>
            </v-list>
          </v-card>
        </template>
      </v-col>
    </v-row>
    <my-snackbar ref="snackbar"/>
  </div>

</template>



<script>
import MySnackbar from "@/components/mySnackbar";
import gql from "graphql-tag";
import partition from "@/utils/partition";
import {UpdateHomework} from "@/graphql/mutations/homework";


const HOMEWORKS = gql`
query ($studentId: ID, $done: Boolean) {
  homeworks(studentId: $studentId, done: $done){
    id
    homeworkManager{
      name
      eventSummary
      end
    }
    time
    daily
  }
}

`

export default {
  components: {MySnackbar},

  data: () => ({
    tab: null,
    homeworksDaily: [],
    homeworksNotDaily: [],
  }),


  apollo: {
    homeworks: {
      skip: function (){
        return this.$store.getters.userCls === undefined
      },
      query: HOMEWORKS,
      variables()  {
        return {
          studentId: this.$store.getters.userCls.id,
          done: false
        }
      },
      update (data){
        [this.homeworksDaily, this.homeworksNotDaily] = partition(data.homeworks,elem => elem.daily )
        const today = new Date().getDate()
        this.homeworksDaily =this.homeworksDaily.filter(h => new Date(h.time).getDate() === today )

        return data
      },
      error(error) {
       this.$refs.snackbar.raiseError(error.message)
        this.clasrooms = []
      },
    },
  },
  methods: {

    async deleteHomework (index, item) {
      await this.$apollo.mutate({
        mutation: UpdateHomework,
        variables: {
          id: item.id,
          done: true
        },
        update: (store,) => {
          // Read the data from our cache for this query.
          const data = store.readQuery({ query: HOMEWORKS, variables:
                {studentId: this.$store.getters.userCls.id,
                  done: false} })
          // Add our tag from the mutation to the end
          data.homeworks.splice(data.homeworks.findIndex(h => h.id === item.id), 1)

          item.daily ? this.homeworksDaily.splice(index, 1)
              : this.homeworksNotDaily.splice(index, 1)

          // Write our data back to the cache.
          store.writeQuery({ query: HOMEWORKS, data , variables:
                {studentId: this.$store.getters.userCls.id,
                  done: false}})
        },


      }).catch((error) => {
        // Error
       this.$refs.snackbar.raiseError(error.message)
      })
    }

  },
}
</script>
